<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-md-6">
        <el-form-item label="Название (UA)" prop="title">
          <el-input v-model="form.title" />
          {{ $_ErrorMixin_getError('title') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Название (RU)" prop="title_ru">
          <el-input v-model="form.title_ru" />
          {{ $_ErrorMixin_getError('title_ru') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Ссылка" prop="url">
          <el-input v-model="form.url" />
          {{ $_ErrorMixin_getError('url') }}
        </el-form-item>
      </div>

      <div class="col-md-3">
        <el-form-item label="Позиция" prop="position">
          <el-input-number v-model="form.position" :min="1" style="width: 100%;" />
          {{ $_ErrorMixin_getError('position') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Диапазон дат и времени" prop="dateRange">
          <el-date-picker
            v-model="dateRange"
            end-placeholder="Дата окончания"
            format="dd.MM.yyyy HH:mm"
            range-separator="—"
            start-placeholder="Дата начала"
            style="width: 100%"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm"
          />
          {{ $_ErrorMixin_getError('start_at') }}
          {{ $_ErrorMixin_getError('end_at') }}
        </el-form-item>
      </div>

      <div class="col-md-3">
        <el-form-item label="Активно" prop="is_active">
          <el-switch v-model="form.is_active" :active-value="true" :inactive-value="false" />
          {{ $_ErrorMixin_getError('is_active') }}
        </el-form-item>
      </div>

      <div class="col-md-12">
        <el-form-item label="Изображение" prop="image">
          <SingleImageEdit
            :image-preview="imagePreview"
            @status-change="addImage"
          />
          {{ $_ErrorMixin_getError('image') }}
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { mapActions } from 'vuex'
import ErrorMixin from '@/utils/ErrorMixin'
import SingleImageEdit from '@/components/common/SingleImageEdit.vue'

const defaultValues = {
  title: '',
  title_ru: '',
  url: '',
  position: 1,
  is_active: true,
}

export default {
  name: 'RunningLineForm',
  components: { SingleImageEdit },
  mixins: [ErrorMixin],
  data() {
    return {
      form: { ...defaultValues },
      formData: new FormData(),
      dateRange: [],
      rules: {
        title: [
          { required: true, message: 'Пожалуйста, введите название (UA)', trigger: 'blur' },
        ],
        title_ru: [
          { required: true, message: 'Пожалуйста, введите название (RU)', trigger: 'blur' },
        ],
        url: [
          { required: true, message: 'Пожалуйста, введите ссылку', trigger: 'blur' },
        ],
        position: [
          { required: true, message: 'Пожалуйста, введите позицию', trigger: 'blur' },
        ],
        dateRange: [
          {
            validator: (rule, value, callback) => {
              if (!this.dateRange || this.dateRange.length !== 2) {
                callback(new Error('Пожалуйста, введите диапазон дат'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
      editMode: false,
      imagePreview: null,
    }
  },
  computed: {
    isUpdate() {
      return this.$route.name === 'UpdateRunningLine'
    },
  },
  watch: {
    'form.is_active': {
      handler(newValue) {
        if (newValue === true) {
          this.dateRange = []
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchRunningLine()
  },
  methods: {
    ...mapActions('runningLines', [
      'createRunningLine',
      'updateRunningLine',
      'getRunningLine',
      'uploadImage',
    ]),
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            for (const key in this.form) {
              if (key === 'image') continue
              this.formData.append(key, this.form[key])
              this.formData.delete('start_at')
              this.formData.delete('end_at')
            }

            this.formData.append('start_at', this.dateRange[0])
            this.formData.append('end_at', this.dateRange[1])

            if (this.isUpdate) {
              await this.updateRunningLine({formData: this.formData, id: this.form.id})
              this.$message.success('Бегущая строка успешно обновлена')
            } else {
              await this.createRunningLine(this.formData)
              this.$message.success('Бегущая строка успешно создана')
            }

            this.$_ErrorMixin_clearErrors()
            this.$router.push({ name: 'RunningLinesList' })
          } catch (error) {
            this.$_ErrorMixin_handleError(error)
          }
        }
      })
    },
    addImage(image) {
      if (!image) return
      this.formData.append('image', image, image?.name);
    },
    async fetchRunningLine() {
      const id = this.$route.params.id
      if (id) {
        const model = await this.getRunningLine(id)
        this.fillForm(model)
        this.imagePreview = model.image

        this.dateRange = [model.start_at, model.end_at]
      }
    },
    fillForm(model) {
      this.form = {
        ...this.form,
        ...model,
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.running-line-form__upload-image
  margin-bottom: 10px

.running-line-form__preview
  margin-top: 10px
  padding: 10px
  border: 1px solid #dcdfe6
  border-radius: 4px
  display: inline-block

.running-line-form__preview-image
  max-width: 200px
  max-height: 200px
  object-fit: contain
</style>


